import { STATUS_RU } from "@/lib/statuses";

// Shared dark-themed admin primitives (Russian UI area).
export function Panel({ title, children, actions }) {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg">
      {(title || actions) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700">
          <h2 className="text-white font-semibold">{title}</h2>
          <div>{actions}</div>
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}

export function Table({ head, children }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left">
        <thead><tr className="text-slate-400 border-b border-slate-700">{head.map((h) => <th key={h} className="py-2 px-3 font-medium whitespace-nowrap">{h}</th>)}</tr></thead>
        <tbody className="text-slate-200">{children}</tbody>
      </table>
    </div>
  );
}

export function Td({ children, className = "" }) {
  return <td className={`py-2 px-3 align-top ${className}`}>{children}</td>;
}

export function Empty({ text = "Нет данных" }) {
  return <p className="text-slate-500 text-sm py-6 text-center">{text}</p>;
}

export function StatusBadge({ value }) {
  return <span className="inline-block px-2 py-0.5 rounded-full text-xs bg-slate-700 text-slate-200 border border-slate-600">{STATUS_RU[value] || value || "-"}</span>;
}

export function fmt(d) {
  try { return new Date(d).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return d || "-"; }
}
